// import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TitlePage } from 'components/atoms'
import CmsStoryGroupApiV2 from 'api/v2/admins/cms-story-group-api-v2'
import CmsStoryGroupForm from 'domains/cms-story-group/form/cms-story-group-form'
import { ALERT_TYPES } from 'constants/alert-constants'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}


const CmsStoryGroupDetailPage = ({ pageUtils }) => {

  const [ cmsStoryGroup, setCmsStoryGroup ] = useState({})
  const [ isSubmitted, setIsSubmitted ]     = useState(false)

  const [ subTitle, setSubTitle ] = useState('Create')
  const { id }                    = useParams()

  useEffect(() => {
    if (id !== undefined) {
      CmsStoryGroupApiV2.show({ id: id })
        .then((response) => {
          setCmsStoryGroup(response.data.story_group)
          setSubTitle('Edit')
        })
        .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
    }
  }, []) //eslint-disable-line

  const handleSubmit = (values, actions) => {
    if (id) {
      CmsStoryGroupApiV2.update({ id: id, params: values })
        .then(() => {
          pageUtils.setAlertMsg('Cms Story Group has been updated', ALERT_TYPES.SUCCESS)
          setIsSubmitted(!isSubmitted)
        })
        .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
    } else {
      CmsStoryGroupApiV2.create({ params: values })
        .then(() => {
          pageUtils.setAlertMsg('Cms Story Group has been created', ALERT_TYPES.SUCCESS)
          actions.resetForm()
          setIsSubmitted(!isSubmitted)
        })
        .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
    }
  }
  return (
    <>
      <TitlePage mainTitle='CMS Story Group' subTitle={ subTitle } />
      <CmsStoryGroupForm
        pageUtils={ pageUtils }
        cmsStoryGroup={ cmsStoryGroup }
        onSubmit={ handleSubmit }
        isSubmitted = { isSubmitted }
      />
    </>
  )
}

CmsStoryGroupDetailPage.propTypes    = propTypes
CmsStoryGroupDetailPage.defaultProps = defaultProps
export default CmsStoryGroupDetailPage
